module.exports = __webpack_public_path__ + "static/media/art3.9eb3c1ef.png";